var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_39278_19113)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1773 7.03906C17.6017 7.03906 15.7412 9.09941 15.245 10.5543C14.3745 12.793 14.742 14.5127 15.0658 16.0292L15.0893 16.1397C15.39 17.5501 15.6737 18.8822 15.2674 20.5542C15.2296 20.7831 15.1626 21.0082 15.0681 21.2233C14.6031 22.2895 13.5487 22.9781 12.3822 22.9781C10.7677 22.9781 9.45414 21.6724 9.45414 20.0671C9.45414 18.4612 10.7677 17.1547 12.3822 17.1547C12.817 17.1547 13.2349 17.2479 13.625 17.4311L13.9651 17.5912L13.5414 15.0161L13.4077 14.9892C13.0722 14.9221 12.7272 14.8883 12.3822 14.8883C9.51129 14.8883 7.17578 17.2114 7.17578 20.0671C7.17578 22.923 9.51129 25.246 12.3822 25.246C14.7655 25.246 16.8396 23.6431 17.4229 21.361C18.0127 19.5736 17.737 17.9428 17.3462 16.148L17.3025 15.9483C16.919 14.193 16.616 12.8065 17.5296 10.9757C18.0104 9.96187 19.0496 9.30655 20.1773 9.30655C21.7912 9.30655 23.1043 10.6122 23.1043 12.2175C23.1043 13.8226 21.7912 15.1288 20.1773 15.1288C19.7773 15.1288 19.3886 15.0498 19.0211 14.8933L18.6908 14.753L19.108 17.2888L19.2452 17.3138C19.5502 17.3686 19.8639 17.3967 20.1773 17.3967C23.0476 17.3967 25.3827 15.0732 25.3827 12.2175C25.3827 9.36205 23.0476 7.03906 20.1773 7.03906Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39278_19113",
    x1: -0.264463,
    y1: 15.1351,
    x2: 29.2813,
    y2: 14.8475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5569DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8572FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.2fb6a8dc89f75f8ba16877a187602346.svg";
export { ForwardRef as ReactComponent };